// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_64-0";